import gql from 'graphql-tag';

const CASE_USAGE_ATTACHMENTS = gql`
  mutation caseUsageAttachments(
    $caseId: String
    $caseExternalId: String!
    $customerPrintedName: String
    $customerTitle: String
    $customerEmail: String
    $repPrintedName: String!
    $attachments: [Attachment]
    $signatureTimestamp: String
  ) {
    caseUsageAttachments(
      caseId: $caseId
      caseExternalId: $caseExternalId
      customerPrintedName: $customerPrintedName
      customerTitle: $customerTitle
      customerEmail: $customerEmail
      repPrintedName: $repPrintedName
      attachments: $attachments
      signatureTimestamp: $signatureTimestamp
    ) {
      message
      externalId
    }
  }
`;

export default CASE_USAGE_ATTACHMENTS;
